export default __webpack_public_path__ + "images/5e322e5ec8d261f1e9569abfccb4cdd6.svg";